import React, { useState } from 'react'
import { Form } from 'react-bootstrap'
import logger from '../../../../utils/logger';

export const InputCheckBox = ({ handleObject, HideReachedValue, defaultPageSize }) => {
  const [checked, setChecked] = useState(true)

  const handleChange = (e) => {
    setChecked(e.target.checked)
    HideReachedValue(e.target.checked)
    // logger.info('e.target.checked INPUT: ',e.target.checked)
    handleObject(
      {

        HideReached: e.target.checked,
        PageSize: defaultPageSize ? defaultPageSize : 10,
        PageIndex: 1,
      }
    )


  }

  return (
    <Form>
      <Form.Check
        className='mb-2 d-flex justify-content-center justify-content-md-end m-md-3 mt-md-0 gap-2'
        type="checkbox"
        checked={checked}
        onChange={handleChange}
        id="default-checkbox"
        label="Ocultar Contactados"
      />
    </Form>
  );
};
